import { AlpineComponent } from 'alpinejs';
//import { Tooltip } from '../../../wwwroot/twistMaster/js/bootstrap.esm';
import { Tooltip } from 'bootstrap';

export default (): AlpineComponent => ({
    init(): void {
        const tooltipElements: Array<HTMLElement> = [].slice.call(this.$el.querySelectorAll('[data-bs-toggle="tooltip"]'));
        const tooltipList = tooltipElements.map(tooltipElement => new Tooltip(tooltipElement));
        let pauseAutoTooltips = false;
        tooltipElements.forEach(tel => {
            tel.onmouseover = (el) => {
                tooltipList.forEach((t, index) => {
                    t.hide();
                });
                pauseAutoTooltips = true;
            };
            tel.onmouseout = (el) => {
                pauseAutoTooltips = false;
            };
        });
        if (tooltipList.length > 1) {
            tooltipList[0].show();
            let nextIndex = 0;
            setInterval(e => {
                if (!pauseAutoTooltips) {
                    nextIndex = tooltipList.length <= nextIndex + 1 ? 0 : nextIndex + 1;
                    tooltipList.forEach((t, index) => {
                        if (index == nextIndex) {
                            t.show();
                        } else {
                            t.hide();
                        }
                    });
                }
            }, 5000);
        }
    },
});